import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routes } from '@platform/core/lib/routes';
import { recordCode } from '../../form/header/recordCode';
import type { IRelatedRowProps } from './IRelatedRowProps';

/**
 * Рядок пов'язаного елемента (UIUX forms/related-items, прототип v4): пігулка типу зв'язку суцільним тоном (мін. 112px, білий 11/700) ·
 * чип типу запису · номер (mono, без префікса типу, як у прототипі) · назва (відкриває запис) · статус мовою інтерфейсу з крапкою · «Розірвати зв’язок».
 */
export function RelatedRow({ link, foreign, canEdit, onUnlink }: IRelatedRowProps) {
  const { t } = useTranslation();
  const status = foreign.status(link.otherModule, link.otherRecordType, link.otherStatus);
  return (
    <div className="rtab-rel">
      <span className={`link-pill link-pill--${link.linkType}`}>{t(`recordPage.linkTypes.${link.linkType}`, { defaultValue: link.linkLabel })}</span>
      <span className="rtab-chip">{foreign.typeLabel(link.otherModule, link.otherRecordType)}</span>
      <span className="rtab-rel__code" title={link.otherDisplay}>{recordCode(link.otherDisplay, link.otherCode)}</span>
      <Link className="rtab-rel__title" to={routes.record(link.otherModule, link.otherRecordType, link.otherRecordId)} title={link.otherTitle}>{link.otherTitle}</Link>
      {link.otherStatus && <span className="rtab-rel__status"><span className="rtab-dot" style={{ background: status.color }} />{status.label}</span>}
      {canEdit && <button type="button" className="rtab-rel__unlink" onClick={() => onUnlink(link)}>{t('recordPage.related.unlink')}</button>}
    </div>
  );
}
